import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import {AuthenticationService} from '../original-services/authentication.service';

@Injectable({ providedIn: 'root' })
export class ResponseInterceptor implements HttpInterceptor {
    private authService: AuthenticationService;
    enabledMonite = environment.monite?.enabled && environment.monite?.moniteApiUrl;
    constructor(private injector: Injector) {
    }

    private isUnauthorizedError(err: HttpErrorResponse, req: HttpRequest<any>): boolean {
        return err.status === 401 && (!this.enabledMonite || !req.url.includes(environment.monite?.moniteApiUrl));
    }
    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap((event: HttpEvent<any>) => {}),
            catchError((err) => {
                if (err instanceof HttpErrorResponse) {
                    if (
                        this.isUnauthorizedError(err, req)
                    ) {
                        console.log(req)
                        this.authService = this.injector.get(
                            AuthenticationService
                        );
                        console.log('err.status === 401 reloading');
                        this.authService.logout(true);
                    }
                }
                return throwError(err);
            })
        );
    }
}
